export enum ReviewStatusEnum {
    NotReady = 1,
    Ready = 2,
    Reviewed = 3,
    Rejected = 4
}
